import { DateTime } from 'luxon';
/**
 * 情報活用ファイルクラス
 */
var PmlFile = /** @class */ (function () {
    function PmlFile(props) {
        this.id = props.id;
        this.title = props.title;
        this.schoolId = props.schoolId;
        this.creatorId = props.creatorId;
        this.creatorName = props.creatorName;
        this.ownerId = props.ownerId;
        this.ownerName = props.ownerName;
        this.thumbnailPath = props.thumbnailPath;
        this.existsOwnerInSchool = props.existsOwnerInSchool;
        this.stamp = props.stamp;
        this.comment = props.comment;
        this.assignmentId = props.assignmentId;
        this.createdDatetime = props.createdDatetime;
        this.updatedDatetime = props.updatedDatetime;
        this.kind = props.kind;
        this.assignment = props.assignment;
    }
    /** graphqlから受け取ったPmlFileJsonObjectをPmlFileオブジェクトに変換するstaticファクトリメソッド */
    PmlFile.fromGql = function (props) {
        var _a;
        return new PmlFile({
            id: props.id,
            title: props.title,
            schoolId: props.schoolId,
            creatorId: props.creatorId,
            creatorName: props.creatorName,
            ownerId: props.ownerId,
            ownerName: props.ownerName,
            thumbnailPath: (_a = props.thumbnailPath) !== null && _a !== void 0 ? _a : '',
            existsOwnerInSchool: props.existsOwnerInSchool,
            stamp: props.stamp || null,
            comment: props.comment || null,
            assignmentId: props.assignmentId || null,
            createdDatetime: DateTime.fromISO(props.createdDatetime),
            updatedDatetime: DateTime.fromISO(props.updatedDatetime),
            kind: props.kind,
            assignment: props.assignment || null,
        });
    };
    Object.defineProperty(PmlFile.prototype, "linkedAssignmentId", {
        get: function () {
            return this.assignmentId !== 'NOT_ASSIGNMENT' ? this.assignmentId : null;
        },
        enumerable: false,
        configurable: true
    });
    return PmlFile;
}());
export { PmlFile };
